if (!customElements.get('woofin-account-menu')) {
  customElements.define('woofin-account-menu', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.details = this.querySelector('details');
      this.trigger = this.querySelector('summary');
      const position = () => {
        const header = this.closest('[data-header-wrapper]')?.querySelector('[data-header-height]');
        const bounds = this.getBoundingClientRect();
        this.style.setProperty('--account-mobile-left', -bounds.left + 'px');
        this.style.setProperty('--account-mobile-width', document.documentElement.clientWidth + 'px');
        if (header) this.style.setProperty('--account-offset', Math.max(0, header.getBoundingClientRect().bottom - this.getBoundingClientRect().bottom) + 'px');
      };
      window.addEventListener('resize', position, options);
      window.addEventListener('scroll', () => { if (this.details.open) position(); }, { ...options, passive: true });
      this.details.addEventListener('toggle', () => { if (this.details.open) position(); }, options);
      const open = () => {
        position();
        clearTimeout(this.closeTimer);
        document.querySelectorAll('woofin-account-menu details[open]').forEach(details => { if (details !== this.details) details.open = false; });
        this.details.open = true;
      };
      this.addEventListener('pointerenter', event => { if (event.pointerType === 'mouse') open(); }, options);
      this.addEventListener('pointerleave', event => { if (event.pointerType === 'mouse') this.closeTimer = setTimeout(() => { if (!this.contains(document.activeElement)) this.details.open = false; }, 180); }, options);
      this.addEventListener('focusin', event => { if (event.target !== this.trigger) open(); }, options);
      this.addEventListener('focusout', event => { if (!this.contains(event.relatedTarget)) this.details.open = false; }, options);
      this.addEventListener('keydown', event => { if (event.key === 'Escape') { this.trigger.focus(); this.details.open = false; event.preventDefault(); } }, options);
      document.addEventListener('pointerdown', event => { if (!this.contains(event.target)) this.details.open = false; }, options);
    }
    disconnectedCallback() { clearTimeout(this.closeTimer); this.controller?.abort(); this.controller = null; }
  });
}
